import { render, staticRenderFns } from "./supervisionMatch.vue?vue&type=template&id=6a6d23a1&scoped=true&"
import script from "./supervisionMatch.vue?vue&type=script&lang=js&"
export * from "./supervisionMatch.vue?vue&type=script&lang=js&"
import style0 from "./supervisionMatch.vue?vue&type=style&index=0&id=6a6d23a1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d23a1",
  null
  
)

export default component.exports